import { AWAGlobalApiService } from '@/services/global-api/awa-global-api.service';

export function isTokenValid(tokens: Awaited<ReturnType<typeof AWAGlobalApiService.verifyOTP>>) {
  if (tokens?.accessTokenExpiration) {
    const tokenExpiration = new Date(Number(tokens.accessTokenExpiration));
    const isValid = tokenExpiration > new Date();
    return isValid;
  }

  return false;
}
